import VideoModal from './VideoModal';

export default VideoModal;



// WEBPACK FOOTER //
// ./scripts/blocks/VideoModal/index.js